import { Transaction, VersionedTransaction } from '@solana/web3.js';
import {
  mockSolEvmChainId,
  getSolBalance,
  sendTransaction as sendTx,
} from '../../../config/sol';
import { initOptions } from '../../types/types';
import BasicProvider from '../BasicProvider';
import PrioviderUtils from '../ProviderUtils';

interface SolTransferParam {
  from: string;
  to: string;
  value: string;
  // chainId: number;
  contract?: string;
}

export default class SolanaProvider extends BasicProvider {
  isConnected: boolean = false;
  utils: PrioviderUtils;
  account: {
    address: string;
  };
  chainId: number;

  constructor(options: initOptions) {
    super(options);
    this.chainId = mockSolEvmChainId;
    this.isConnected = false;
    this._initialize();
  }

  private _initialize() {
    const account = this.utils.storage.get(`accounts`)?.sol;
    if (account) {
      this.account = account;
      this.isConnected = true;
    }
  }

  async connectWallet(params?: { email: string }) {
    const res = await super.connect('sol_connectWallet', params);
    this.isConnected = true;
    this.account = res as any;
    return res;
  }

  async disconnectWallet() {
    await this.disconnect();
    this.isConnected = false;
    return true;
  }

  async sendTransaction(tx: string) {
    const res = await sendTx(tx);
    return res;
  }

  async getBalance(address?: string) {
    if (!address && !this.account?.address)
      return { balance: '0', formatted: '0' };
    const res = await getSolBalance({
      address: address || this.account.address,
      token: '',
    });
    return res;
  }

  async signMessage(message: string) {
    const res = await this.utils.request({
      method: 'sol_signMessage',
      params: [message, this.getAddress()],
    });
    return res.result;
  }

  getAddress() {
    return this.account?.address || '';
  }

  async signTransaction(tx: Transaction | SolTransferParam) {
    // fall back to transfer
    if (typeof (tx as any)?.serialize != 'function')
    { 
      console.error(`warning: signTransaction using plain js object will be deprecated\nsignTransaction will only accept a Transaction Instance in the future\nfor simple transfer ops, please use 'transfer' method`);
      return this.transfer(tx as SolTransferParam);
    }
    const txHex = (tx as Transaction)
      .serialize({ requireAllSignatures: false, verifySignatures: false })
      .toString('hex');

    const res = await this.utils.request({
      method: 'sol_signTx',
      params: [{ chainId: this.chainId, txHex }],
    });
    return res.result;
  }

  async transfer(params: SolTransferParam) {
    const param = {
      method: 'sol_signTransaction', // 'sol_transfer'
      params: [{ ...params, chainId: this.chainId }],
    };
    const res = await this.utils.request(param);
    return res.result;
  }

  async transferToken(params: SolTransferParam) {
    return this.transfer(params);
  }

  // TODO:
  // async signTransactions(params: any[]) {
  //   const res = await this.utils.request({
  //     method: 'sol_signTransaction',
  //     params: params,
  //   });
  //   return res.result;
  // }

  async disconnect() {
    this.account = null;
    super.disconnect('sol_disconnect');
  }
}
